import { z } from "zod";
import { DocTypeTypes } from "./document-types";

export const sectionThreeLocationTypeValues = [
  "LOCATION",
  "AXES",
  "RANKS",
  "MARKS",
  "FLOORS",
  "TIERS",
  "SECTIONS",
  "PREMISES",
] as const;

export type SectionThreeLocationType =
  (typeof sectionThreeLocationTypeValues)[number];

const sectionThreeCompanySchema = z.object({
  companyId: z
    .string({ required_error: "Укажите организацию" })
    .uuid("Неверный формат ID организации"),
  projectParticipantId: z
    .string({ required_error: "Укажите участника проекта" })
    .uuid("Неверный формат ID участника проекта"),
});

export const sectionThirdFormSchema = z.object({
  companyList: z
    .array(sectionThreeCompanySchema)
    .min(1, "Добавьте организацию / участника"),
  workDate: z.string({
    message: "Укажите дату выполнения работ",
  }).refine((val) => !!val, {
    message: "Укажите дату выполнения работ",
  }),
  workType: z.any().optional(),
  workName: z
    .string({
      required_error: "Укажите наименование выполняемой работы",
      invalid_type_error: "Укажите наименование выполняемой работы",
    })
    .nonempty("Укажите наименование выполняемой работы")
    .max(255, "Максимальная длина — 255 символов"),
  workCondition: z.string().max(255, "Максимальная длина — 255 символов").optional(),
  locationDescription: z
    .string({
      required_error: "Укажите описание места выполнения работы",
      invalid_type_error: "Укажите описание места выполнения работы",
    })
    .nonempty("Укажите описание места выполнения работы")
    .max(255, "Максимальная длина — 255 символов"),
  locationType: z.enum(sectionThreeLocationTypeValues, {
    required_error: "Укажите тип местоположения",
    invalid_type_error: "Укажите тип местоположения",
  }),
  signerId: z
    .string({
      required_error: "Выберите уполномоченного представителя (подписанта)",
      invalid_type_error: "Неверный формат подписанта",
    })
    .nonempty("Выберите уполномоченного представителя (подписанта)"),
  docs: z
    .array(
      z.object({
        docId: z.string().min(1, "Документ должен содержать docId"),
        docType: z.nativeEnum(DocTypeTypes),
      }),
    )
    .refine(
      (docs) =>
        docs.some((doc) => doc.docType === DocTypeTypes.PROJECT_DOC) ||
        docs.some((doc) => doc.docType === DocTypeTypes.WORK_DOC),
      {
        message: "Добавьте проектную и рабочую документацию",
      },
    )
    .refine(
      (docs) => docs.some((doc) => doc.docType === DocTypeTypes.REGULATION_DOC),
      {
        message: "Добавьте нормативную документацию",
      },
    ),
  actionDetails: z.string().max(255, "Максимальная длина — 255 символов").optional(),
});

export type SectionThirdFormType = z.infer<typeof sectionThirdFormSchema>;
